var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfilePlaceholder = function SvgProfilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M0 0h94v94H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.142 34c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20ZM10 82.571c0-15.2 24.746-22.857 37.143-22.857 12.396 0 37.143 7.657 37.143 22.857V94H10V82.57Z",
    fill: "#E5E7EB"
  })));
};
export default SvgProfilePlaceholder;